module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/216-england-3dbd3e6b2b0489881503f28f26c69f90.svg";